import type { Leader as LeaderResponse } from 'services/api/proxy-achievement/data-contracts';
import type { AchievementLeader } from 'services/api/proxy-bff-web/data-contracts';
import happen from 'utils/happen';
import { Product } from 'contracts';

import { config } from './top-models.settings';
import { type PeriodOption, type LeaderItem, type Leader } from './contracts';

const isPeriodOption = (value: string): value is PeriodOption => {
  const periodOptions = ['month', 'week', 'day'];

  return periodOptions.includes(value);
};

const isLeaderItemLeader = (leader: LeaderItem): leader is Leader => {
  return 'points' in leader && 'performer' in leader;
};

const isLeaderResponse = (leader): leader is LeaderResponse => {
  return 'globalRank' in leader && 'points' in leader && 'performer' in leader;
};

const isSummerLeaderResponse = (leader): leader is AchievementLeader => {
  return isLeaderResponse(leader) && 'potentialPrize' in leader;
};

const getLastMonthNameAndYear = (today: Date): string => {
  // Convert date to LUX midnight
  const luxMidnightDate = new Date(today.toISOString().split('T')[0]);

  luxMidnightDate.setMonth(luxMidnightDate.getMonth() - 1);

  return `${luxMidnightDate.toLocaleString('default', { month: 'long' })} ${luxMidnightDate.getFullYear()}`;
};

const isSummerContestEnabled = (product: Product, now: Date = new Date()): boolean => {
  return product === Product.LiveJasmin && happen(now.getTime()).greaterThan(new Date(config.summerContestStartDate));
};

export {
  isPeriodOption,
  isLeaderItemLeader,
  isLeaderResponse,
  isSummerLeaderResponse,
  getLastMonthNameAndYear,
  isSummerContestEnabled,
};
